<p-dialog header="Edit Recurring Sub Job" [modal]="true" [(visible)]="visibleEditJobPopup"
          [breakpoints]="{ '991px': '90vw' }"
          [style]="{ width: '70vw' }" showEffect="fade"
          [draggable]="false"
          [resizable]="false"
          (onHide)="closeJobDialog()">

    <div *ngIf="loading" class="card mt-3">
        <div class="p-fluid p-formgrid grid gap-3 px-3 pt-3">
            <div class="field p-formgrid grid md:grid-cols-2 gap-3 px-3">
                <div class="field">
                    <label>Shift Start Time</label>
                    <p-skeleton width="100%" height="1.5rem" styleClass="mb-2"></p-skeleton>
                </div>
                <div class="field">
                    <label>Shift End Time</label>
                    <p-skeleton width="100%" height="1.5rem" styleClass="mb-2"></p-skeleton>
                </div>
            </div>

            <div class="field">
                <label>Assign Staff</label>
                <p-skeleton width="100%" height="1.5rem" styleClass="mb-2"></p-skeleton>
            </div>
        </div>
        <div class="flex items-center justify-end">
            <p-skeleton width="5rem" height="1.5rem" styleClass="mb-2"></p-skeleton>
        </div>
    </div>

    <div *ngIf="!loading" class="card mt-3">
        <div class="p-fluid p-formgrid grid gap-3 px-3 pt-3">
            <div class="field p-formgrid grid md:grid-cols-2 gap-3 px-3">
                <div class="field">
                    <label>Shift Start Time</label>
                    <p-dropdown
                        (ngModelChange)="onShiftStartTimeChange($event)"
                        [options]="this.timeOptions"
                        [(ngModel)]="shiftStartTime"
                        placeholder="Select Time"
                        optionValue="value"
                        optionLabel="label">
                    </p-dropdown>
                </div>
                <div class="field">
                    <label>Shift End Time</label>
                    <p-dropdown
                        (ngModelChange)="onShiftEndTimeChange($event)"
                        [options]="this.timeOptions"
                        [(ngModel)]="shiftEndTime"
                        placeholder="Select Time"
                        optionValue="value"
                        optionLabel="label">
                    </p-dropdown>
                </div>
            </div>

            <div class="field">
                <label>Assign Staff</label>
                <p-multiSelect [options]="staffOptions" [(ngModel)]="staff" placeholder="Select Staff"
                               optionLabel="name" class="multiselect-custom" display="chip" appendTo="body">
                    <ng-template let-Staff pTemplate="item">
                        <div class="flex align-items-center">
                            <span class="ml-2">{{ Staff.name }}</span>
                        </div>
                    </ng-template>
                </p-multiSelect>
            </div>
        </div>
        <div class="flex items-center justify-end">
            <button [loading]="saveJobLoading" pButton pRipple
                    type="button" class="rounded-full w-fit"
                    (click)="this.isModifiedRecurringExist  ? saveData() : createData()">
                Save
            </button>
        </div>
    </div>
</p-dialog>
